export default async function setList({ state }, { hitlistTaskListId, hitlistTaskList }) {
  const statePath = ['hitlistTask', 'list', hitlistTaskListId];
  state.set(statePath, hitlistTaskList);
}
